export default (timeStr?: string): string | null => {
  const regex = /^\s*(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(am|pm)?\s*$/i;
  const time = regex.exec(timeStr || '');
  if (!time) {
    return null;
  }

  let hour = parseInt(time[1], 10);
  const minute = parseInt(time[2], 10);
  const second = time[3] ? parseInt(time[3], 10) : 0;
  const ampm = time[4] ? time[4].toLowerCase() : null;

  if (ampm) {
    if (ampm === 'pm' && hour < 12) {
      hour += 12;
    }
    if (ampm === 'am' && hour === 12) {
      hour = 0;
    }

    return `${String(hour).padStart(2, '0')}:${String(minute).padStart(
      2,
      '0',
    )}:${String(second).padStart(2, '0')}`;
  }

  const startTimeParts: number[] | undefined = timeStr?.split(':').map(Number);
  if (startTimeParts?.length) {
    return `${(startTimeParts[0] || '').toString().padStart(2, '0')}:${(
      startTimeParts[1] || ''
    )
      .toString()
      .padStart(2, '0')}:${(startTimeParts[2] || '')
      .toString()
      .padStart(2, '0')}`;
  }

  return timeStr || '';
};
